import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { request } from '@/api/index';
import { uploadParams } from '@/api/';
export function getList(params) {
  return request({
    url: '/api/PTypeTemplate/Data',
    method: 'get',
    params: params
  });
}
export function getBusinessType(params) {
  return request({
    url: '/api/PTypeTemplate/GetBusinessType',
    method: 'get',
    params: params
  });
}
export function create(data) {
  return request({
    url: '/api/PTypeTemplate/Create',
    method: 'post',
    data: data
  });
}
export function getDataByStrucCode(params) {
  return request({
    url: '/api/PTypeTemplate/DataByStrucCode',
    method: 'get',
    params: params
  });
}
export function edit(data) {
  return request({
    url: '/api/PTypeTemplate/Edit',
    method: 'post',
    data: data
  });
}
export function deleteItems(params) {
  return request({
    url: '/api/PTypeTemplate/Delete',
    method: 'post',
    params: params
  });
}
export function downloadTemplate(data) {
  return request({
    url: '/CPMS/PTypeTemplate/DownloadTemplate',
    method: 'get',
    data: data
  });
}
export function importFile(data) {
  return request(_objectSpread(_objectSpread({}, uploadParams), {}, {
    url: '/CPMS/PTypeTemplate/Import',
    data: data
  }));
}
var getTmp = '/CPMS/PTypeTemplate/GetTmp';
var exportInfo = '/api/PTypeTemplate/Export';
export { getTmp, exportInfo };